export const HOTEL_FAQ_TEST_ID = 'HOTEL_FAQ_TEST_ID';
export const HOTEL_FAQ_HEADER_TEST_ID = 'HOTEL_FAQ_HEADER_TEST_ID';
